export function assertNever(_: never): never {
  throw new Error(`Expected value to be never and this code to never reach`);
}
